export const nationalityOptions = [
  { label: 'Afghanistan', value: 'AF' },
  { label: 'Albania', value: 'AL' },
  { label: 'Algeria', value: 'DZ' },
  { label: 'Andorra', value: 'AD' },
  { label: 'Angola', value: 'AO' },
  { label: 'Antigua e Barbuda', value: 'AG' },
  { label: 'Arabia Saudita', value: 'SA' },
  { label: 'Argentina', value: 'AR' },
  { label: 'Armenia', value: 'AM' },
  { label: 'Australia', value: 'AU' },
  { label: 'Austria', value: 'AT' },
  { label: 'Azerbaigian', value: 'AZ' },
  { label: 'Bahamas', value: 'BS' },
  { label: 'Bahrein', value: 'BH' },
  { label: 'Bangladesh', value: 'BD' },
  { label: 'Barbados', value: 'BB' },
  { label: 'Belgio', value: 'BE' },
  { label: 'Belize', value: 'BZ' },
  { label: 'Benin', value: 'BJ' },
  { label: 'Bhutan', value: 'BT' },
  { label: 'Bielorussia', value: 'BY' },
  { label: 'Bolivia', value: 'BO' },
  { label: 'Bosnia ed Erzegovina', value: 'BA' },
  { label: 'Botswana', value: 'BW' },
  { label: 'Brasile', value: 'BR' },
  { label: 'Brunei', value: 'BN' },
  { label: 'Bulgaria', value: 'BG' },
  { label: 'Burkina Faso', value: 'BF' },
  { label: 'Burundi', value: 'BI' },
  { label: 'Cambogia', value: 'KH' },
  { label: 'Camerun', value: 'CM' },
  { label: 'Canada', value: 'CA' },
  { label: 'Capo Verde', value: 'CV' },
  { label: 'Ciad', value: 'TD' },
  { label: 'Cile', value: 'CL' },
  { label: 'Cina', value: 'CN' },
  { label: 'Cipro', value: 'CY' },
  { label: 'Colombia', value: 'CO' },
  { label: 'Comore', value: 'KM' },
  { label: 'Congo', value: 'CG' },
  { label: 'Corea del Nord', value: 'KP' },
  { label: 'Corea del Sud', value: 'KR' },
  { label: "Costa d'Avorio", value: 'CI' },
  { label: 'Costa Rica', value: 'CR' },
  { label: 'Croazia', value: 'HR' },
  { label: 'Cuba', value: 'CU' },
  { label: 'Danimarca', value: 'DK' },
  { label: 'Dominica', value: 'DM' },
  { label: 'Ecuador', value: 'EC' },
  { label: 'Egitto', value: 'EG' },
  { label: 'El Salvador', value: 'SV' },
  { label: 'Emirati Arabi Uniti', value: 'AE' },
  { label: 'Eritrea', value: 'ER' },
  { label: 'Estonia', value: 'EE' },
  { label: 'Etiopia', value: 'ET' },
  { label: 'Figi', value: 'FJ' },
  { label: 'Filippine', value: 'PH' },
  { label: 'Finlandia', value: 'FI' },
  { label: 'Francia', value: 'FR' },
  { label: 'Gabon', value: 'GA' },
  { label: 'Gambia', value: 'GM' },
  { label: 'Georgia', value: 'GE' },
  { label: 'Germania', value: 'DE' },
  { label: 'Ghana', value: 'GH' },
  { label: 'Giamaica', value: 'JM' },
  { label: 'Giappone', value: 'JP' },
  { label: 'Gibuti', value: 'DJ' },
  { label: 'Giordania', value: 'JO' },
  { label: 'Grecia', value: 'GR' },
  { label: 'Grenada', value: 'GD' },
  { label: 'Guatemala', value: 'GT' },
  { label: 'Guinea', value: 'GN' },
  { label: 'Guinea-Bissau', value: 'GW' },
  { label: 'Guinea Equatoriale', value: 'GQ' },
  { label: 'Guyana', value: 'GY' },
  { label: 'Haiti', value: 'HT' },
  { label: 'Honduras', value: 'HN' },
  { label: 'India', value: 'IN' },
  { label: 'Indonesia', value: 'ID' },
  { label: 'Iran', value: 'IR' },
  { label: 'Iraq', value: 'IQ' },
  { label: 'Irlanda', value: 'IE' },
  { label: 'Islanda', value: 'IS' },
  { label: 'Israele', value: 'IL' },
  { label: 'Italia', value: 'IT' },
  { label: 'Kazakistan', value: 'KZ' },
  { label: 'Kenya', value: 'KE' },
  { label: 'Kirghizistan', value: 'KG' },
  { label: 'Kuwait', value: 'KW' },
  { label: 'Laos', value: 'LA' },
  { label: 'Lettonia', value: 'LV' },
  { label: 'Libano', value: 'LB' },
  { label: 'Liberia', value: 'LR' },
  { label: 'Libia', value: 'LY' },
  { label: 'Liechtenstein', value: 'LI' },
  { label: 'Lituania', value: 'LT' },
  { label: 'Lussemburgo', value: 'LU' },
  { label: 'Macedonia del Nord', value: 'MK' },
  { label: 'Madagascar', value: 'MG' },
  { label: 'Malawi', value: 'MW' },
  { label: 'Malaysia', value: 'MY' },
  { label: 'Maldive', value: 'MV' },
  { label: 'Mali', value: 'ML' },
  { label: 'Malta', value: 'MT' },
  { label: 'Marocco', value: 'MA' },
  { label: 'Mauritania', value: 'MR' },
  { label: 'Mauritius', value: 'MU' },
  { label: 'Messico', value: 'MX' },
  { label: 'Micronesia', value: 'FM' },
  { label: 'Moldavia', value: 'MD' },
  { label: 'Monaco', value: 'MC' },
  { label: 'Mongolia', value: 'MN' },
  { label: 'Montenegro', value: 'ME' },
  { label: 'Mozambico', value: 'MZ' },
  { label: 'Namibia', value: 'NA' },
  { label: 'Nauru', value: 'NR' },
  { label: 'Nepal', value: 'NP' },
  { label: 'Nicaragua', value: 'NI' },
  { label: 'Niger', value: 'NE' },
  { label: 'Nigeria', value: 'NG' },
  { label: 'Norvegia', value: 'NO' },
  { label: 'Nuova Zelanda', value: 'NZ' },
  { label: 'Oman', value: 'OM' },
  { label: 'Paesi Bassi', value: 'NL' },
  { label: 'Pakistan', value: 'PK' },
  { label: 'Palau', value: 'PW' },
  { label: 'Panama', value: 'PA' },
  { label: 'Papua Nuova Guinea', value: 'PG' },
  { label: 'Paraguay', value: 'PY' },
  { label: 'Perù', value: 'PE' },
  { label: 'Polonia', value: 'PL' },
  { label: 'Portogallo', value: 'PT' },
  { label: 'Qatar', value: 'QA' },
  { label: 'Regno Unito', value: 'GB' },
  { label: 'Repubblica Ceca', value: 'CZ' },
  { label: 'Repubblica Centrafricana', value: 'CF' },
  { label: 'Repubblica Dominicana', value: 'DO' },
  { label: 'Romania', value: 'RO' },
  { label: 'Ruanda', value: 'RW' },
  { label: 'Russia', value: 'RU' },
  { label: 'Saint Kitts e Nevis', value: 'KN' },
  { label: 'Saint Lucia', value: 'LC' },
  { label: 'Saint Vincent e Grenadine', value: 'VC' },
  { label: 'Samoa', value: 'WS' },
  { label: 'San Marino', value: 'SM' },
  { label: 'Sao Tome e Principe', value: 'ST' },
  { label: 'Senegal', value: 'SN' },
  { label: 'Serbia', value: 'RS' },
  { label: 'Seychelles', value: 'SC' },
  { label: 'Sierra Leone', value: 'SL' },
  { label: 'Singapore', value: 'SG' },
  { label: 'Siria', value: 'SY' },
  { label: 'Slovacchia', value: 'SK' },
  { label: 'Slovenia', value: 'SI' },
  { label: 'Somalia', value: 'SO' },
  { label: 'Spagna', value: 'ES' },
  { label: 'Sri Lanka', value: 'LK' },
  { label: 'Stati Uniti', value: 'US' },
  { label: 'Sudafrica', value: 'ZA' },
  { label: 'Sudan', value: 'SD' },
  { label: 'Sudan del Sud', value: 'SS' },
  { label: 'Suriname', value: 'SR' },
  { label: 'Svezia', value: 'SE' },
  { label: 'Svizzera', value: 'CH' },
  { label: 'Swaziland', value: 'SZ' },
  { label: 'Tagikistan', value: 'TJ' },
  { label: 'Thailandia', value: 'TH' },
  { label: 'Taiwan', value: 'TW' },
  { label: 'Tanzania', value: 'TZ' },
  { label: 'Timor Est', value: 'TL' },
  { label: 'Togo', value: 'TG' },
  { label: 'Tonga', value: 'TO' },
  { label: 'Trinidad e Tobago', value: 'TT' },
  { label: 'Tunisia', value: 'TN' },
  { label: 'Turchia', value: 'TR' },
  { label: 'Turkmenistan', value: 'TM' },
  { label: 'Tuvalu', value: 'TV' },
  { label: 'Ucraina', value: 'UA' },
  { label: 'Uganda', value: 'UG' },
  { label: 'Ungheria', value: 'HU' },
  { label: 'Uruguay', value: 'UY' },
  { label: 'Uzbekistan', value: 'UZ' },
  { label: 'Vanuatu', value: 'VU' },
  { label: 'Città del Vaticano', value: 'VA' },
  { label: 'Venezuela', value: 'VE' },
  { label: 'Vietnam', value: 'VN' },
  { label: 'Yemen', value: 'YE' },
  { label: 'Zambia', value: 'ZM' },
  { label: 'Zimbabwe', value: 'ZW' },
];
